<template>
  <div>
    <app-home-page-header />
    <app-header-mobile />
    <app-side-nav />
    <div>
      <div class="topShape" style="">
        <div
          class="circle"
          id="circle1"
          style="left: -220.281px; top: 216.45px"
        ></div>
        <div
          class="circle"
          id="circle2"
          style="left: 770.742px; top: -550.55px"
        ></div>
        <div
          class="circle"
          id="circle3"
          style="left: 160.403px; top: -162.05px"
        ></div>
        <div
          class="circle"
          id="circle4"
          style="left: 725.069px; top: 26.45px"
        ></div>
        <div class="headerSvg">
          <img src="@/assets/img/home-reverse.svg" height="auto" width="auto" />
        </div>
      </div>
    </div>
    <div class="main_slider">
      <div class="main_slider_bg_part">
        <div class="container-lg" style="height: 445px" v-show="isPlaceholder">
          <vue-content-loading :width="300" :height="115" />
        </div>

        <div class="container-lg" v-show="isImageLoaded">
          <div class="slider_top">
            <!--            <h1 class="">Welcome to financing happiness!</h1>-->
            <h1>{{ pageSliderHeader.first_title }}</h1>
            <div class="buttons">
              <a
                href="/apply-for-deposit"
                target="_blank"
                class="home-apply-for-loan-button"
              >
                <h6 class="home-apply-for-loan-button">Apply for Deposit</h6>
              </a>
              <a
                href="/apply-for-loan"
                target="_blank"
                class="home-apply-for-loan-button"
              >
                <h6 class="home-apply-for-loan-button">Apply For Loan</h6>
              </a>
              <a
                href="https://idlc.com/login/login.php"
                target="_blank"
                class="home-account-login-button"
              >
                <h6 class="home-account-login-button">Customer Login</h6>
              </a>
            </div>
          </div>
          <div class="slider">
            <div v-if="sliders.length > 0">
              <carousel
                :autoplay="false"
                :nav="false"
                :items="1"
                :dots="true"
                id="items"
              >
                <a
                  class="item slideItem"
                  v-for="(slideItem, index) in sliders"
                  :key="slideItem.id"
                  :id="'slide_' + index"
                  :href="slideItem.button_link"
                  target="_blank"
                >
                  <div class="item_overlay">
                    <div class="item_tex">
                      <h2 class="animate__animated animate__backInLeft">
                        {{ slideItem.title }}
                      </h2>
                      <p class="animate__animated animate__fadeInUp">
                        {{ slideItem.subtitle }}
                      </p>
                    </div>
                  </div>
                  <picture>
                    <img
                      :src="slideItem.image"
                      @load="onImageLoad"
                      alt="Slider Image"
                    />
                  </picture>
                </a>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="comment_section">
      <div class="container">
        <div class="row comment_gap">
          <div class="col-lg-6 col-12 lg-mb-0 mb-5">
            <div class="card_body">
              <div class="main_img">
                <img
                  v-if="comments.length > 0 && comments[0].image_url"
                  :src="comments[0].image_url"
                />
              </div>
              <div class="content text-right pr-5">
                <img src="@/assets/img/coma.png" alt="" />
                <div class="d-flex justify-content-end">
                  <p v-if="comments.length > 0 && comments[0].quote">
                    {{ comments[0].quote }}
                  </p>
                </div>
                <h3 v-if="comments.length > 0 && comments[0].name">
                  {{ comments[0].name }}
                </h3>
                <div v-if="comments.length > 0 && comments[0].designation">
                  {{ comments[0].designation }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="card_body">
              <div class="content text-left pl-5">
                <img class="img-fluid" src="@/assets/img/coma.png" alt="" />
                <div class="d-flex justify-content-start">
                  <p v-if="comments.length > 0 && comments[1].quote">
                    {{ comments[1].quote }}
                  </p>
                </div>
                <h3 v-if="comments.length > 0 && comments[1].name">
                  {{ comments[1].name }}
                </h3>
                <div v-if="comments.length > 0 && comments[1].designation">
                  {{ comments[1].designation }}
                </div>
              </div>
              <div class="main_img">
                <img
                  v-if="comments.length > 0 && comments[1].image_url"
                  :src="comments[1].image_url"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="for_mobile mb-5">
          <div class="card_wrapper">
            <div class="comment px-4">
              <img class="my-3" src="@/assets/img/coma.png" alt="" />
              <p v-if="comments.length > 0 && comments[0].quote">
                {{ comments[0].quote }}
              </p>
            </div>
            <div class="name_img">
              <img
                v-if="comments.length > 0 && comments[0].image_url"
                :src="comments[0].image_url"
              />
              <div class="name text-right mb-4 mr-4">
                <h3 v-if="comments.length > 0 && comments[0].name">
                  {{ comments[0].name }}
                </h3>
                <div v-if="comments.length > 0 && comments[0].designation">
                  {{ comments[0].designation }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="for_mobile">
          <div class="card_wrapper">
            <div class="comment px-4">
              <img class="my-3" src="@/assets/img/coma.png" alt="" />
              <p v-if="comments.length > 0 && comments[1].quote">
                {{ comments[1].quote }}
              </p>
            </div>
            <div class="name_img">
              <div class="name text-left mb-4 ml-4">
                <h3 v-if="comments.length > 0 && comments[1].name">
                  {{ comments[1].name }}
                </h3>
                <div v-if="comments.length > 0 && comments[1].designation">
                  {{ comments[1].designation }}
                </div>
              </div>
              <img
                v-if="comments.length > 0 && comments[1].image_url"
                :src="comments[1].image_url"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-lg">
      <h2
        class="featuredProductHeading h2Responsive"
        style="
          text-align: center;
          margin-top: 30px;
          color: #2d2a29;
          text-transform: uppercase;
        "
      >
        Featured Products
      </h2>
      <div class="featuredProduct">
        <div class="featuredProduct_box">
          <router-link to="/home-loan">
            <div class="featuredProduct_box_inner">
              <div class="icon icon_1"></div>
              <div class="heading">
                <h1>Home Loan</h1>
              </div>
              <div class="short_detail">
                <p>
                  IDLC Home Loan gives you the confidence to purchase own space
                  to live in freedom.
                </p>
              </div>
              <span class="featuredProductLearnMore">Learn More</span>
            </div>
          </router-link>
        </div>
        <div class="featuredProduct_box">
          <router-link to="/sme-loan">
            <div class="featuredProduct_box_inner">
              <div class="icon icon_2"></div>
              <div class="heading">
                <h1>SME Loan</h1>
              </div>
              <div class="short_detail">
                <p>
                  IDLC SME Loan features convenient repayment to reduce the
                  burden on your finances.
                </p>
              </div>
              <span class="featuredProductLearnMore">Learn More</span>
            </div>
          </router-link>
        </div>
        <div class="featuredProduct_box">
          <router-link to="/term-deposit">
            <div class="featuredProduct_box_inner">
              <div class="icon icon_3">
                <!-- <img src="./img/menuIcons/deposit/Deposits-Icon.png" alt="" /> -->
              </div>
              <div class="heading">
                <h1>Deposits</h1>
              </div>
              <div class="short_detail">
                <p>
                  Choose IDLC, and enjoy a life free of worry, the life that you
                  and your family deserve!
                </p>
              </div>
              <span class="featuredProductLearnMore">Learn More</span>
            </div>
          </router-link>
        </div>
        <div class="featuredProduct_box">
          <router-link to="/corporate-loan">
            <div class="featuredProduct_box_inner">
              <div class="icon icon_4">
                <!-- <img src="./img/menuIcons/deposit/Deposits-Icon.png" alt="" /> -->
              </div>
              <div class="heading">
                <h1>Corporate Loan</h1>
              </div>
              <div class="short_detail">
                <p>
                  Make your corporate endeavor a success with our innovative and
                  comprehensive solutions
                </p>
              </div>
              <span class="featuredProductLearnMore">Learn More</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!--Product Feature  Part End-->
    <!-- <app-latest-news-slide/> -->
    <!--Latest news and updates part start-->
    <div class="container-lg">
      <h2
        class="h2Responsive"
        style="
          text-align: center;
          color: #2d2a29;
          margin: 15px 0 20px 0;
          text-transform: uppercase;
        "
      >
        Latest news and updates
      </h2>

      <div class="latest_news slider multiple-items">
        <!-- <div class="owl-carousel owl-theme" id="latestNews"> -->
        <div v-if="allNews.length > 0">
          <carousel
            :loop="true"
            :autoplay="true"
            :nav="true"
            :items="4"
            :dots="false"
            :navText="[prev, next]"
            :responsive="{
              0: { items: 1, nav: true },
              600: { items: 1, nav: true },
              1000: { items: 4, nav: true },
            }"
          >
            <div
              class="news_box_gutter"
              v-for="newsData in allNews"
              :key="newsData.id"
            >
              <div class="news_box">
                <div class="news_box_image">
                  <img :src="newsData.image" alt="" />
                  <!--                    <img v-lazy="newsData.image" alt="">-->
                </div>
                <div class="news_box_header">
                  <h2>{{ newsData.title }}</h2>
                  <p style="font-size: 10px; margin: 10px 0">
                    Published Date: {{ newsData.publish_date }}
                  </p>
                </div>
                <div class="news_box_body">
                  <p>
                    The largest financial institution IDLC launches an e-loan
                    fair named 'IDLC-ShopUp Online Purnota Loan Fair' with the
                    leading online business platform “ShopUp” to provide e-loan
                    facilities to the women entrepreneurs in e-commerce and
                    f-commerce sector dated August 16, 2020.
                  </p>
                </div>
                <div class="news_box_footer">
                  <router-link
                    class="news_box_learnMore_btn"
                    :to="{ name: 'News', params: { newsId: newsData.id } }"
                  >
                    Read More
                  </router-link>
                  <!-- <a class="news_box_learnMore_btn" href="#">Read More</a> -->
                </div>
                <div class="news_box_share">
                  <!-- <span>Share On</span> -->
                  <!--                  <ShareNetwork-->
                  <!--                    title=""-->
                  <!--                    network="facebook"-->
                  <!--                    :url="shareBase+newsData.id"-->
                  <!--                  >-->
                  <!--                    <span class="icon-facebook-f"></span>-->
                  <!--                  </ShareNetwork>-->
                  <!--                  <ShareNetwork-->
                  <!--                    title=""-->
                  <!--                    network="linkedin"-->
                  <!--                    :url="shareBase+newsData.id"-->
                  <!--                  ><span class="icon-linkedin"></span></ShareNetwork>-->

                  <a
                    class=""
                    title="Share on Facebook"
                    target="_blank"
                    :href="
                      'https://www.facebook.com/sharer/sharer.php?u=https://web.idlc.com/share/' +
                      newsData.id
                    "
                  >
                    <span class="icon-facebook-f"></span>
                  </a>
                  <a
                    title="Share on Linked In"
                    target="_blank"
                    :href="
                      'https://www.linkedin.com/sharer/sharer.php?u=https://web.idlc.com/share/' +
                      newsData.id
                    "
                  >
                    <span class="icon-linkedin"></span>
                  </a>
                </div>
              </div>
            </div>
          </carousel>
        </div>
        <!-- </div> -->
      </div>
      <div
        class="container-lg text-center"
        style="padding-top: 24px; padding-bottom: 2px"
      >
        <a
          href="news-and-events"
          class="tabcontent2Button quickLinksButton"
          style="
            padding: 6px 10px !important;
            font-size: 12px;
            margin: auto;
            text-align: center;
          "
        >
          See All News
        </a>
      </div>
    </div>
    <!--Latest news and updates part start-->
    <!-- <app-why-choose/> -->
    <!--Why Chose Part Start-->
    <div class="whyChose">
      <div class="top_curve"></div>
      <div class="whyChoseBg">
        <div class="container-lg">
          <div class="header">
            <h2 class="h2Responsive">WHY CHOOSE IDLC?</h2>
          </div>
          <div class="body">
            <div class="reason" v-if="homePageLowerTabContent">
              <img :src="homePageLowerTabContent.why_choose_one_image" alt="" />
              <h5>{{ homePageLowerTabContent.why_choose_one_title }}</h5>
              <div class="line"></div>
              <p>{{ homePageLowerTabContent.why_choose_one_subtitle }}</p>
            </div>
            <div class="reason" v-if="homePageLowerTabContent">
              <img :src="homePageLowerTabContent.why_choose_two_image" alt="" />
              <h5>{{ homePageLowerTabContent.why_choose_two_title }}</h5>
              <div class="line"></div>
              <p>{{ homePageLowerTabContent.why_choose_two_subtitle }}</p>
            </div>
            <div class="reason" v-if="homePageLowerTabContent">
              <img
                :src="homePageLowerTabContent.why_choose_three_image"
                alt=""
              />
              <h5>{{ homePageLowerTabContent.why_choose_three_title }}</h5>
              <div class="line"></div>
              <p>{{ homePageLowerTabContent.why_choose_three_subtitle }}</p>
            </div>
            <div class="reason" v-if="homePageLowerTabContent">
              <img
                :src="homePageLowerTabContent.why_choose_four_image"
                alt=""
              />
              <h5>{{ homePageLowerTabContent.why_choose_four_title }}</h5>
              <div class="line"></div>
              <p>{{ homePageLowerTabContent.why_choose_four_subtitle }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_curve"></div>
    </div>
    <!--Why Chose Part End-->
    <!-- <app-quick-links/> -->
    <section class="quickLinks">
      <h2 class="h2Responsive text-center" style="text-transform: uppercase">
        Quick links
      </h2>
      <p class="text-center shortDescription">
        Here's some more from our side to help make your investment journey
        smoother
      </p>
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-xl-3" style="margin-bottom: 15px">
              <div class="quickLinkBox quicklinkBox_1">
                <div class="blockHeading">
                  <h4>Monthly Business Review</h4>
                </div>
                <div class="quickLinks_career_box review" style="">
                  <a :href="mbr.title_link" class="QLMBRTitle">
                    <div class="headPart">
                      <div class="image">
                        <div class="bluryImage"></div>
                        <img :src="mbr.image" alt="" />
                      </div>
                      <br />
                      <div class="Text" style="">
                        <!-- <h5>Career at IDLC</h5> -->
                        <a
                          :href="mbr.title_link"
                          class="QLMBRTitle"
                          target="_blank"
                        >
                          <p>{{ mbr.title }}</p>
                        </a>
                      </div>
                    </div>
                  </a>
                  <div class="jobs"></div>
                  <a
                    :href="mbr.link"
                    target="_blank"
                    class="tabcontent2Button quickLinksButton"
                    style="
                      /* padding: 5px 5px !important; */
                      padding-left: 12px !important;
                      padding-right: 12px !important;
                      font-size: 12px;
                      margin: 0;
                    "
                    >View More</a
                  >
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3" style="margin-bottom: 15px">
              <div class="quickLinkBox quicklinkBox_2">
                <div class="blockHeading">
                  <h4>Career at IDLC</h4>
                </div>
                <a
                  href="https://apps.idlc.com/career#/jobs"
                  target="_blank"
                  class="quickLinks_career_box"
                  v-if="homePageData.careers"
                >
                  <div class="headPart">
                    <div class="icon">
                      <img src="@/assets/img/q_link_news/career-B.png" alt="" />
                    </div>
                    <div class="Text">
                      <!-- <h5>Career at IDLC</h5> -->
                      <p class="heighlightedText">
                        Get a chance to work with the professionals
                      </p>
                    </div>
                  </div>
                  <div class="jobs">
                    <router-link
                      :to="{
                        name: 'ApplyForJobs',
                        params: { id: homePageData.careers.id },
                      }"
                      class="job"
                    >
                      <h6>{{ homePageData.careers.title }}</h6>
                      <!--                        <span>{{ career.short_desc}}</span>-->
                    </router-link>
                  </div>
                  <br />
                  <router-link
                    :to="{
                      name: 'ApplyForJobs',
                      params: { id: homePageData.careers.id },
                    }"
                    class="tabcontent2Button quickLinksButton"
                    style="
                      padding: 5px 5px !important;
                      font-size: 12px;
                      margin: 0;
                    "
                    >See More Vacancies
                  </router-link>
                </a>
                <a
                  href="https://apps.idlc.com/career#/jobs"
                  target="_blank"
                  class="quickLinks_career_box"
                  style="cursor: pointer"
                  v-else
                >
                  <div class="headPart">
                    <div class="icon">
                      <img src="@/assets/img/q_link_news/career-B.png" alt="" />
                    </div>
                    <div class="Text">
                      <!-- <h5>Career at IDLC</h5> -->
                      <p class="heighlightedText">
                        Get a chance to work with the professionals
                      </p>
                    </div>
                  </div>
                  <div class="openOnlinePortalButtons">
                    <a
                      href="https://apps.idlc.com/career#/jobs"
                      target="_blank"
                      class="tabcontent2Button quickLinksButton"
                      style="padding: 5px 5px !important; font-size: 12px"
                      >Apply Here</a
                    >
                  </div>
                  <br />
                  <!--                  <router-link :to="{ name: 'ApplyForJobs', params: { id : homePageData.careers.id }}"-->
                  <!--                               class="tabcontent2Button quickLinksButton"-->
                  <!--                               style="padding: 5px 5px !important; font-size: 12px; margin: 0;">See More Vacancies-->
                  <!--                  </router-link>-->
                </a>
              </div>
            </div>
            <div class="col-md-6 col-xl-3" style="margin-bottom: 15px">
              <div class="quickLinkBox quicklinkBox_3">
                <div class="blockHeading">
                  <h4>Online Service Portal</h4>
                </div>
                <div class="quickLinks_career_box">
                  <div class="headPart">
                    <div class="icon">
                      <img
                        src="@/assets/img/q_link_news/Online-Service-Portal.png"
                        alt=""
                      />
                    </div>
                    <div class="Text">
                      <!-- <h5>Career at IDLC</h5> -->
                      <p class="heighlightedText">
                        Open IDLC Online Service Portal Account
                      </p>
                    </div>
                  </div>
                  <div class="jobs text-center">
                    <h6 class="text-center" style="font-size: 14px">
                      The best of IDLC, all in one place.
                    </h6>
                  </div>

                  <div class="openOnlinePortalButtons">
                    <a
                      href="https://onlineservices.idlc.com:8443"
                      target="_blank"
                      class="tabcontent2Button quickLinksButton"
                      style="padding: 5px 5px !important; font-size: 12px"
                      >Deposit Services</a
                    >
                    <a
                      href="https://onlineservices.idlc.com/login.php"
                      target="_blank"
                      class="tabcontent2Button quickLinksButton"
                      style="padding: 5px 5px !important; font-size: 12px"
                      >Loan Services</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-3" style="margin-bottom: 15px">
              <div class="quickLinkBox quicklinkBox_4">
                <div
                  id=""
                  class=""
                  data-sf-element="Container"
                  data-placeholder-label="col-md-4 col-sm-6"
                >
                  <h4 style="font-size: 1.25rem; text-align: center">
                    Latest Stock Price
                  </h4>

                  <div
                    id="formFundsOfFunds"
                    class="fundsOfFunds ng-scope cardslider cardslider--direction-right"
                    ng-controller="CommonFundController"
                  >
                    <ul class="cardslider__cards">
                      <li
                        class="cardslider__card cardslider__card--transitions false cardslider__card--index-0"
                        aria-hidden="false"
                        style="z-index: 4"
                      >
                        <div class="fundCard hoverStyle insideCardBox">
                          <div class="cardTop" style="z-index: 11">
                            <div class="starhot"></div>
                            <div class="toolTipHover toolTipDown cardTopInfo">
                              <a href="#" class="infoTootip icon-info"></a>
                              <div class="tooltip">
                                <div class="tooltip-inner">
                                  <p>
                                    An open ended equity scheme predominantly
                                    investing in large cap stocks.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <!-- <div class="subTitle">Category A Company</div> -->
                            <h2 class="text-center">
                              <a
                                href="/our-funds/equity-funds/bluechip-fund"
                                id="SchemeOptionName"
                                >IDLC Finance PLC</a
                              >
                            </h2>

                            <div class="row">
                              <div class="col-md-6 col-xs-5">
                                <div
                                  class="cartfundType fundTitle ng-binding"
                                  id="FundName_1191"
                                  value="EQUITY FUNDS"
                                ></div>
                              </div>
                            </div>
                          </div>

                          <div class="cardMiddle">
                            <div class="row">
                              <div class="cardBox cagr eliptext">
                                <div class="title">
                                  <span class="Name"
                                    >Latest Stock Price <br />
                                    (Today)</span
                                  >
                                </div>

                                <div class="amount arrow">
                                  {{ financialData.OPENPRICE }}
                                </div>
                              </div>
                              <div class="cardBox cagr eliptext">
                                <div class="title">
                                  <span class="Name"
                                    >Yesterday's Stock <br />
                                    Price</span
                                  >
                                </div>

                                <div class="amount arrow">
                                  {{ financialData.YESTARDAYCLOSEPRICE }}
                                </div>
                              </div>
                              <div class="cardBox cagr eliptext">
                                <div class="title">
                                  <span class="Name"
                                    >Percentage<br />
                                    Change</span
                                  >
                                </div>
                                <br class="displayNone" />
                                <div class="amount arrow">
                                  {{ financialData.PERCENTAGE }}%
                                </div>
                              </div>
                            </div>
                          </div>
                          <router-link
                            to="/financial-reports"
                            class="cardBottom btn btn-danger"
                          >
                            Download Latest Financial Report
                          </router-link>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <!--Product Slider Part End-->
    </section>
    <app-footer />
  </div>
</template>

<script type="text/javascript">
import { defineAsyncComponent } from "vue";
import VueContentLoading from "vue-content-loading";

import axios from "axios";

export default {
  metaInfo: {
    title: "IDLC Finance PLC - Loans, Deposits, SME and Corporate Finance",
    meta: [
      {
        name: "description",
        content:
          "IDLC is the Largest Non-Banking Financial Institution in Bangladesh. See what the largest NBFI in Bangladesh has to offer for all your financial needs",
      },
      {
        name: "keywords",
        content:
          "bank, banking, deposit, loan, nbfi, bangladesh, apply loan, nbfi in Bangladesh, Bangladesh",
      },
    ],
  },
  components: {
    VueContentLoading,
    AppHeaderMobile: defineAsyncComponent(
      () => import("../../incudes/HeaderMobile"),
    ),
    AppHomePageHeader: defineAsyncComponent(
      () => import("../../incudes/HomePageHeader"),
    ),
    AppSideNav: defineAsyncComponent(() => import("../../incudes/SideNav")),
    AppFooter: defineAsyncComponent(() => import("../../incudes/Footer")),
  },
  data() {
    return {
      prev: "<span class='icon-chevron-left'></span>",
      next: "<span class='icon-chevron-right'></span>",
      shortcode: "Home",
      isImageLoaded: false,
      isPlaceholder: true,
      homePageData: 0,
      sliders: [],
      pageSliderHeader: "",
      allNews: [],
      homePageLowerTabContent: {},
      mbr: {},
      financialData: {},
      menuVideos: {},
      menuNews: [],
      shareBase: this.$store.state.shareBaseUrl,
      comments: [],
      get requestPermission() {
        return localStorage.getItem("notificationPref") === null;
      },
      set requestPermission(value) {
        localStorage.setItem("notificationPref", value);
      },
    };
  },
  name: "Index",
  methods: {
    getHomeSliderData() {
      axios
        .get(`homepage-slider?shortcode=Home`)
        .then((res) => {
          const sliders = res.data;
          // sliders.forEach(slider => {
          //   console.log('slider =>', slider)
          // });
          const newArray = sliders.sort(
            (a, b) => Number(a.order) - Number(b.order),
          );

          this.sliders = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getHomePageData() {
      axios
        .get("get-home-page-detail")
        .then((response) => {
          if (response.status == 200) {
            this.homePageData = response.data.details;
            this.pageSliderHeader = response.data.details.page_data;
            this.allNews = response.data.details.allNews;
            this.homePageLowerTabContent =
              response.data.details.homePageTabContent;
            this.mbr = response.data.details.mbr;
            //this.sliders = response.data.details.slider;
            this.financialData = response.data.details.financialData;
            this.menuVideos = response.data.details.menuVideos;
            this.menuNews = response.data.details.menuNews;
            console.log(response.data.details.financialData);
          }
        })
        .catch((error) => console.log(error));
    },
    onImageLoad() {
      this.isPlaceholder = false;
      this.isImageLoaded = true;
    },
    async getComments() {
      try {
        await axios
          .get("homepage-quote")
          .then((res) => {
            this.comments = res.data.homeQuote;
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log("error =>", error);
      }
    },
    async initFirebaseMessaging() {
      // API key referrer rules block localhost; never init messaging in Vite dev.
      if (import.meta.env.DEV) return;

      const host = window.location.hostname;
      const isLocal =
        host === "localhost" ||
        host === "127.0.0.1" ||
        host === "[::1]" ||
        host.endsWith(".local");
      if (isLocal || !window.isSecureContext) return;

      try {
        const firebase = (await import("firebase/app")).default;
        await import("firebase/messaging");
        if (!firebase.messaging.isSupported()) return;

        const config = {
          apiKey: "AIzaSyBfACkqgIjjTo6G5bQQxrVazyBPzurFgoE",
          authDomain: "idlc-revamp.firebaseapp.com",
          projectId: "idlc-revamp",
          storageBucket: "idlc-revamp.appspot.com",
          messagingSenderId: "586313753410",
          appId: "1:586313753410:web:3d9123f302fb28353a5edb",
          measurementId: "G-MF9S1N718D",
        };
        if (!firebase.apps.length) {
          firebase.initializeApp(config);
        }

        const messaging = firebase.messaging();
        await messaging.requestPermission();
        const token = await messaging.getToken();
        if (!token) return;

        const response = await fetch(
          "https://iid.googleapis.com/iid/v1/" + token + "/rel/topics/news",
          {
            method: "POST",
            headers: new Headers({
              Authorization:
                "key=AAAAiIMF40I:APA91bHdebX-NaHIhZ7PScNc1yfL3LtxBCKT2s9_Qc7U2o47WfCWJc63WbbguQV4bdsoeE91O5qvhc34mgQaiIiiGuaublbpMR2Viy97UP6AO2RUFutWRU9Vjcppp7bPjXCqIj3rUO78",
            }),
          },
        );
        if (response.status < 200 || response.status >= 400) {
          throw new Error("Error subscribing to topic: " + response.status);
        }
      } catch (err) {
        console.warn("Firebase messaging unavailable:", err?.message || err);
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    next((vm) => {
      // <= HERE you execute next
      vm.getHomePageData();
    });
  },

  created() {
    // this.getHomePageData()
    this.getHomeSliderData();
    this.getComments();
  },

  mounted() {
    this.initFirebaseMessaging();
  },
};
</script>
<style scoped>
.topShape {
  height: 445.4px;
}

@media (max-width: 1030px) {
  .topShape {
    height: 350.4px;
  }
}

@media (max-width: 600px) {
  .topShape {
    height: 250.4px;
  }
}

.owl-dots {
  text-align: center;
  -webkit-tap-highlight-color: transparent;
  position: absolute !important;
  bottom: 80px;
  left: 105px;
}

.featuredProduct_box a:hover {
  color: inherit !important;
}

.news_box_gutter {
  padding: 0 10px;
}

@media screen and (max-width: 600px) {
  .news_box_gutter {
    padding: 0 0px;
    margin-bottom: 2px;
  }
}

.news_box {
  width: 100%;
  border: 1px solid #ccc;
  padding: 0;
  overflow: hidden;
  position: relative;
  margin: 0 0px;
}

.news_box:focus {
  box-shadow: none;
  outline: none;
}

.news_box .news_box_image {
  width: 100%;
  overflow: hidden;
}

.news_box .news_box_image img {
  width: 100%;
  transition: all 0.4s;
}

.news_box:hover .news_box_image img {
  transform: scale(1.2);
}

.news_box .news_box_header {
  width: 100%;
  padding: 15px 20px 10px 20px;
}

.news_box .news_box_header h2,
.news_box .news_box_body p {
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.news_box .news_box_header h2 {
  font-size: 1.25rem;
  -webkit-line-clamp: 3;
  height: 74px;
}

.news_box .news_box_body {
  padding: 0 20px 20px 20px;
  display: none;
}

.news_box .news_box_body p {
  font-size: 14px;
  -webkit-line-clamp: 3;
}

.news_box .news_box_footer {
  padding: 0 20px 20px 20px;
}

.news_box .news_box_footer .news_box_learnMore_btn {
  display: inline-block;
  border: 1px solid #d62e2f;
  color: #d62e2f;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 100px;
  transition: all 0.4s;
}

.news_box .news_box_footer .news_box_learnMore_btn:hover {
  color: #fff;
  background: #d62e2f;
  text-decoration: none;
}

.news_box .news_box_share {
  background: #d62e2f;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 130px;
  padding: 5px 10px;
  transform: rotate(-90deg) translateX(32%);
  transform-origin: right bottom;
  position: absolute;
  top: 0;
  right: -100px;
  transition: all 0.4s;
}

.news_box .news_box_share span,
.news_box .news_box_share a i {
  color: #fff;
  font-size: 20px;
}

.news_box .news_box_share a {
  color: #fff;
  font-size: 20px;
  transition: all 0.3s;
  transform: rotate(90deg) scale(1);
}

.news_box .news_box_share a:hover {
  transform: rotate(90deg) scale(1.2);
}

.news_box:hover .news_box_share {
  right: 0;
}

.QLMBRTitle {
  cursor: pointer;
}

.QLMBRTitle:hover {
  text-decoration: none;
}

.quickLinks {
  margin-bottom: 20px;
}

.quickLinks .shortDescription {
  font-size: 14px;
  margin: 15px 0 20px 0;
}

.quickLinkBox {
  margin: 0px;
}

.quickLinkBox .blockHeading {
  text-align: center;
}

.quickLinkBox .blockHeading h4 {
  font-size: 1.25rem;
}

.quickLinks_career_box {
  border: 1px solid #ffe4e4;
  border-radius: 1rem;
  padding: 20px 10px 20px 10px;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  display: block;
  background: #f9f9f9;
  color: #000;
  clear: both;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin-top: 15px;
  height: 290px;
  overflow: hidden;
}

.quickLinks_career_box:hover {
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.1);
  background: #fff;
  text-decoration: none;
  cursor: default;
}

.quickLinks_career_box .headPart {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin-bottom: 15px;
}

.quickLinks_career_box .headPart .icon {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.quickLinks_career_box .heighlightedText {
  font-weight: bold;
  transition: all 0.4s;
}

.quickLinks_career_box:hover .heighlightedText {
  color: #d62e2f;
}

.quickLinks_career_box .headPart .icon img {
  width: 100%;
  margin-bottom: 10px;
  transition: all 0.4s;
}

.quickLinks_career_box:hover .headPart .icon img {
  filter: invert(6%) sepia(100%) saturate(9999%);
}

.quickLinks_career_box .headPart .icon img {
  width: 100%;
}

.quickLinks_career_box .headPart .image {
  width: 100%;
  height: 143px;
  overflow: hidden;
  position: relative;
}

.quickLinks_career_box .headPart .image .bluryImage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("@/assets/img/mbr_01.330c1b9 (2).jpg");
  filter: blur(8px);
  -webkit-filter: blur(8px);
}

.quickLinks_career_box .headPart .image img {
  transition: all 0.3s;
  height: 100%;
  width: auto;
  filter: blur(0px);
  -webkit-filter: blur(0px);
}

.quickLinks_career_box .headPart .Text p {
  font-size: 14px;
  color: #000;
  transition: all 0.3s;
}

.quickLinks_career_box .headPart .Text a:hover p {
  font-size: 14px;
  color: #d62e2f;
  text-decoration: none;
}

.quickLinks_career_box:hover .headPart .Text a {
  text-decoration: none;
}

.quickLinks_career_box .jobs {
  display: flex;
  justify-content: center;
  width: 100%;
}

.quickLinks_career_box .jobs a {
  color: #333;
  transition: all 0.3s;
  margin-bottom: 15px;
  display: block;
  text-align: center;
  /* flex-basis: 50%; */
  padding: 0 5px;
}

.quickLinks_career_box .jobs a:not(:last-child) {
  border-right: 1px solid #333;
}

.quickLinks_career_box .jobs a h6 {
  font-size: 14px;
}

.quickLinks_career_box .jobs a:hover {
  color: #d62e2f;
  text-decoration: none;
}

.quickLinks_career_box.review {
  padding: 0px;
}

@media screen and (max-width: 600px) {
  .quickLinkBox {
    margin-bottom: 20px;
  }

  .quickLinks_career_box {
    height: auto;
  }

  .quickLinkBox .fundsOfFunds {
    height: auto;
    min-height: 290px;
  }

  .quickLinks_career_box.review {
    padding-bottom: 20px;
  }

  .displayNone {
    display: none;
  }
}

.quickLinkBox .fundsOfFunds {
  height: 290px;
  margin-top: 15px;
}

.quickLinkBox .fundsOfFunds .cardslider__cards,
.quickLinkBox .fundsOfFunds .cardslider__card {
  height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.fundCard {
  overflow: hidden;
  border-radius: 1rem;
  border: solid 1px #ffe4e4;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* margin-bottom: 3rem; */
}

.fundCard .cardTop {
  padding: 1rem 1rem 0rem 1rem;
  background-color: #f0f8ff;
  position: relative;
}

.fundCard .cardMiddle {
  padding: 2rem 0.5rem 1rem 0.5rem;
}

.fundCard .cardBottom {
  padding: 1rem 2rem;
  border-top: solid 1px #dcdcdc;
  font-size: 14px;
}

.fundCard .cardTop .cart {
  display: inline-block;
  font-size: 2.6rem;
  line-height: 2.6rem;
  color: #d62e2f;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.fundCard .cardTop .toolTipHover .nextButton {
  display: inline-block;
  position: relative;
  font-size: 14px;
  outline: 0;
  cursor: pointer;
  background: #fff;
  padding: 4px 10px;
  border: 2px solid #d62e2f;
  border-radius: 30px;
  text-decoration: none;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  color: #d62e2f;
}

.cardTop h2 {
  padding-bottom: 1.25rem;
}

.cardTop h2 a {
  font-size: 1.25rem;
  color: #000000;
}

.cardTop h2 a:hover {
  text-decoration: none;
}

.cardTop h2 a:before {
  font-size: 1.3rem;
  color: #ffffff !important;
  z-index: 9;
}

.fundCard .cardMiddle {
  /* padding: 3rem 2rem 3rem 2rem; */
  background: #f9f9f9;
  transition: all 0.3s;
  flex: 1;
  display: flex;
  align-items: center;
}

.fundCard:hover .cardMiddle {
  background: #fff;
}

.fundCard.insideCardBox .cardMiddle .cardBox {
  border: none;
  float: left;
  width: 50%;
  padding: 0 0 0 1.5rem;
}

.fundCard.insideCardBox .cardMiddle .cardBox {
  border: none;
  float: left;
  width: 33%;
  padding: 0 0 0 0.25rem;
  text-align: center;
}

.cardBox .amount.arrow {
  position: relative;
}

.fundCard.insideCardBox .cardMiddle .cardBox .descrpi {
  font-size: 0.9rem;
  color: #5e6977;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title .Name {
  font-size: 12px;
}

.fundCard.insideCardBox .cardMiddle .cardBox .amount {
  font-size: 1.25rem;
}

.fundCard.insideCardBox .suitableFor {
  color: #000;
  margin-bottom: 0.5rem;
  /* min-height: 8.6rem; */
}

.fundCard .cardTop:before {
  content: "";
  position: absolute;
  background: rgba(214, 46, 47, 0.95);
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  -ms-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  opacity: 1;
  top: -20px;
  bottom: -0.6rem;
  left: -7rem;
  right: -7rem;
  border-radius: 50%;
  z-index: -10;
  color: #ffffff;
}

.fundCard .cardTop h2 a {
  color: #ffffff !important;
}

.fundCard:hover .cardTop .subTitle {
  color: #ffffff !important;
}

.fundCard:hover .cardTop .equityCap {
  color: #ffffff !important;
}

.fundCard .cardBottom {
  padding: 1rem 1rem;
  border-top: solid 1px #dcdcdc;
  background-color: #d62e2f;
  width: 100%;
  transition: all 0.3s;
}

.fundCard .cardBottom:hover {
  border-top: solid 1px #dcdcdc;
  background-color: #2a2626;
  width: 100%;
}

.quickLinksButton {
  padding: 5px 7px !important;
  font-size: 12px;
}

.fundCard {
  transition: all 0.3s;
}

.fundCard:hover {
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.1);
  background: #fff;
  text-decoration: none;
  cursor: default;
}

.main_slider {
  position: relative;
  width: 100%;
  /* z-index: -1; */
}

.main_slider .main_slider_bg_part {
  border-radius: 0 0 50% 50%;
  z-index: 1;
  margin-top: 75px;
}

.main_slider .main_slider_bg_part .slider_top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  z-index: 10;
}

.main_slider .main_slider_bg_part .slider_top h1 {
  font-size: 35px !important;
  color: #fff;
  margin-bottom: 10px;
}

.main_slider .main_slider_bg_part .slider_top .buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  gap: 10px;
}

.main_slider .main_slider_bg_part .slider_top .buttons a {
  background: #ff1818;
  padding: 10px 15px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: flex;
  align-items: center;
  -webkit-box-shadow: 0 0px 10px 7px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0px 10px 7px rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.main_slider .main_slider_bg_part .slider_top .buttons a:nth-child(1) {
  background: #8c1919;
  color: #fff !important;
}
.main_slider .main_slider_bg_part .slider_top .buttons a:nth-child(2) {
  background: #8c1919;
  color: #fff !important;
}

.main_slider .main_slider_bg_part .slider_top .buttons a:nth-child(3) {
  background: #fff;
  color: #2d2a29;
}

.main_slider .main_slider_bg_part .slider_top .buttons a:hover {
  -webkit-transform: scaleY(1) translateY(0px);
  transform: scaleY(1) translateY(0px);
  -webkit-box-shadow: 0 0px 20px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0px 20px 8px rgba(0, 0, 0, 0.2);
  text-decoration: none;
  background: linear-gradient(45deg, #7a1a1b, #ef0934);
  color: #fff;
}

.main_slider .main_slider_bg_part .slider {
  -webkit-box-shadow: 0 0px 10px 7px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0px 10px 7px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.main_slider .main_slider_bg_part .slider img {
  width: 100%;
}

.main_slider .main_slider_bg_part .slider .item {
  position: relative;
}

.main_slider .main_slider_bg_part .slider .item .item_tex {
  position: absolute;
  bottom: 50px;
  right: 30px;
  color: #fff;
  text-align: right;
  padding: 15px 7px;
  opacity: 0;
  border-radius: 5px;
  -webkit-animation: slidetext 0.4s ease-in-out 0.5s forwards;
  animation: slidetext 0.4s ease-in-out 0.5s forwards;
}
.main_slider .main_slider_bg_part .slider .item .item_tex h2 {
  font-size: 2rem;
}
.main_slider .main_slider_bg_part .slider .item .item_tex p {
  font-size: 1.25rem;
}

.item_overlay {
  /*background-color: rgba(0, 0, 0, 0.34);*/
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

@media screen and (max-width: 770px) {
  .main_slider .main_slider_bg_part {
    margin-top: 15px;
  }
  .main_slider .main_slider_bg_part .slider_top {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .main_slider .main_slider_bg_part .slider_top h1 {
    font-size: 25px !important;
  }
  .main_slider .main_slider_bg_part .slider_top .buttons {
    -ms-flex-item-align: end;
    align-self: flex-end;
  }
  .main_slider .main_slider_bg_part .slider_top .buttons h6 {
    font-size: 10px;
  }
  .main_slider .main_slider_bg_part .slider #owl-demo .item img {
    height: 200px !important;
  }
  .main_slider .main_slider_bg_part .slider .item .item_tex {
    width: 100%;
    bottom: 15px;
    right: 8px;
  }
  .main_slider .main_slider_bg_part .slider .item .item_tex h2 {
    font-size: 20px;
  }
  .main_slider .main_slider_bg_part .slider .item .item_tex p {
    font-size: 1rem;
  }
}

@-webkit-keyframes slidetext {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slidetext {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.owl-dots {
  text-align: center;
  -webkit-tap-highlight-color: transparent;
  position: absolute !important;
  bottom: 80px;
  left: 105px;
}
.featuredProduct {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 20px 0 15px 0;
}

.featuredProduct_box {
  -ms-flex-preferred-size: 32%;
  flex-basis: 32%;
  padding: 3px;
  position: relative;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.featuredProduct_box a {
  color: inherit;
}

.featuredProduct_box a:hover {
  text-decoration: none;
}

.featuredProduct_box::after,
.featuredProduct_box::before {
  content: "";
  height: 0%;
  width: 0%;
  background: #d62e2f;
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.featuredProduct_box::before {
  top: 0;
  right: 0;
}

.featuredProduct_box::after {
  bottom: 0;
  left: 0;
}

.featuredProduct_box:hover::before,
.featuredProduct_box:hover::after {
  height: 100%;
  width: 100%;
}

.featuredProduct_box_inner {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 30px 30px 50px 30px;
  text-align: center;
  position: relative;
}

.featuredProduct_box_inner .icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 10px auto;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.featuredProduct_box_inner .icon img {
  width: 100%;
}

.featuredProduct_box_inner .icon_1 {
  background-image: url("@/assets/img/menuIcons/personalLoan/Home-Loan.png");
}

.featuredProduct_box_inner .icon_2 {
  background-image: url("@/assets/img/menuIcons/SME/Small-Business.png");
}

.featuredProduct_box_inner .icon_3 {
  background-image: url("@/assets/img/menuIcons/deposit/Deposits-Icon.png");
}
.featuredProduct_box_inner .icon_4 {
  background-image: url("@/assets/img/menuIcons/deposit/Corporate-Loan-01.png");
  background-size: 100% 100%;
}

.featuredProduct_box_inner .heading {
  margin-bottom: 10px;
}

.featuredProduct_box_inner .heading h1 {
  font-size: 1.25rem;
}

.featuredProduct_box_inner .short_detail p {
  font-size: 14px;
}

.featuredProduct_box_inner .featuredProductLearnMore {
  display: block;
  width: 100%;
  border: 2px solid #d62e2f !important;
  color: #fff;
  background: #d62e2f;
  font-size: 15px;
  cursor: pointer;
  padding: 7px;
  margin-top: 15px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  visibility: hidden;
  opacity: 0.5;
  -webkit-transition: all 0.4s;
  transition: all 0.3s;
  text-align: center;
}

.featuredProduct_box:hover
  .featuredProduct_box_inner
  > .featuredProductLearnMore {
  visibility: visible;
  opacity: 1;
}

.featuredProduct_box:hover .featuredProduct_box_inner > .icon_1 {
  background-image: url("@/assets/img/menuIcons/personalLoan/Home-Loan-02.png");
}

.featuredProduct_box:hover .featuredProduct_box_inner > .icon_2 {
  background-image: url("@/assets/img/menuIcons/SME/Small-Business-02.png");
}

.featuredProduct_box:hover .featuredProduct_box_inner > .icon_3 {
  background-image: url("@/assets/img/menuIcons/deposit/Deposits-Icon-02.png");
}
.featuredProduct_box:hover .featuredProduct_box_inner > .icon_4 {
  background-image: url("@/assets/img/menuIcons/deposit/Corporate-Loan-02.png");
}

@media screen and (max-width: 600px) {
  .featuredProductHeading {
    font-size: 25px;
  }
  .featuredProduct {
    margin-top: 15px;
    padding: 0px 0 35px 0;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }
  .featuredProduct_box {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
    /* z-index: -1; */
  }
  .featuredProduct_box_inner {
    padding: 20px;
    padding: 15px 30px 50px 30px;
  }
  .featuredProduct_box_inner .heading {
    margin-bottom: 10px;
  }
  .featuredProduct_box_inner .heading h1 {
    font-size: 1.4rem;
  }
  .featuredProduct_box_inner .featuredProductLearnMore {
    visibility: visible;
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.whyChose {
  /* height: 530px; */
  /* background-image: url("@/assets/img/whyChoose.jpg"); */
  background-attachment: fixed;
  background-size: 100% auto;
  position: relative;
}

.whyChose .top_curve {
  background: url("@/assets/img/curveShapeWhite.png") top center;
  top: 0rem;
  background-size: cover;
  height: 5rem;
  width: 100%;
  position: absolute;
  z-index: 100;
}

.whyChose .bottom_curve {
  background: url("@/assets/img/curveShapeWhiteUp.png") top center;
  bottom: 0rem;
  background-size: cover;
  height: 5rem;
  width: 100%;
  position: absolute;
  z-index: 100;
}

.whyChose .whyChoseBg {
  background: rgba(214, 46, 47, 0.95);
  height: 100%;
  padding: 100px 0px 70px 0px;
  margin: 0 auto;
  color: #fff;
}

.whyChose .whyChoseBg .header {
  font-size: 2rem;
}

.whyChose .whyChoseBg .header h2 {
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

.whyChose .whyChoseBg .body {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 20px 0 50px 0;
  text-align: center;
}

.whyChose .whyChoseBg .body .reason {
  -ms-flex-preferred-size: 23%;
  flex-basis: 23%;
  padding: 15px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 5px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.whyChose .whyChoseBg .body .reason img {
  width: 65px;
  margin-bottom: 15px;
}

.whyChose .whyChoseBg .body .reason .line {
  margin: 10px 30px;
  height: 1px;
  background: #fff;
}

.whyChose .whyChoseBg .body .reason p {
  font-size: 14px;
}

.whyChose .whyChoseBg .body .reason:hover {
  background: rgba(255, 255, 255, 0.25);
}

@media screen and (max-width: 770px) {
  .whyChose {
    height: auto;
  }
  .whyChose .top_curve {
    top: -0.1rem;
  }
  .whyChose .bottom_curve {
    bottom: -0.1rem;
  }
  .whyChose .whyChoseBg {
    padding: 100px 0px;
  }
  .whyChose .whyChoseBg .header h2 {
    width: unset;
    font-size: 25px;
  }
  .whyChose .whyChoseBg .body {
    margin: 25px 0 25px 0;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .whyChose .whyChoseBg .body .reason {
    -ms-flex-preferred-size: 49%;
    flex-basis: 49%;
    margin-bottom: 7px;
    padding: 10px;
  }
  .whyChose .whyChoseBg .body .reason img {
    width: 50px;
    margin-bottom: 10px;
  }
}
.comment_section {
  margin: 60px 0;
}
.comment_section .comment_gap {
}
.comment_section .comment_gap .card_body {
  background-image: url("@/assets/img/comment_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  align-items: center;
  border-radius: 14.2963px;
  overflow: hidden;
}
.comment_section .comment_gap .card_body .main_img {
  width: 50%;
  height: 100%;
}
.comment_section .comment_gap .card_body .main_img img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center;
}
.comment_section .comment_gap .card_body .content {
  width: 50%;
  height: 100%;
}
.comment_section .comment_gap .card_body .content p {
  font-weight: 400;
  font-size: 12.0148px;
  line-height: 21px;
  color: #1f2221;
  margin-top: 14px;
  width: 234px;
}
.comment_section .comment_gap .card_body .content h3 {
  font-weight: 700;
  font-size: 15.0148px;
  line-height: 21px;
  color: #2e2f2f;
  margin-top: 12px;
}
.comment_section .comment_gap .card_body .content div {
  font-weight: 500;
  font-size: 14.0148px;
  line-height: 21px;
  color: #2e2f2f;
}
.comment_section .comment_gap .card_body .content img {
  width: 40px;
}
.for_mobile {
  display: none;
}
@media (max-width: 1199.99px) {
  .comment_section .comment_gap .card_body .main_img img {
    height: 255px;
  }

  .comment_section .comment_gap .card_body .content p {
    font-size: 11.0148px;
    line-height: 15px;
  }
}
@media (max-width: 499.99px) {
  .comment_gap {
    display: none !important;
  }
  .for_mobile {
    display: block;
    background-image: url("@/assets/img/comment_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 10px;
    overflow: hidden;
  }
  .for_mobile .card_wrapper {
    width: 100%;
    height: 100%;
  }
  .for_mobile .card_wrapper .comment img {
    width: 40px;
  }
  .for_mobile .card_wrapper .name_img {
    display: flex;
    align-items: end;
  }
  .for_mobile .card_wrapper .name_img img {
    width: 50%;
  }
  .for_mobile .card_wrapper .name_img .name {
    width: 50%;
  }
  .for_mobile .card_wrapper .name_img .name h3 {
    font-weight: 700;
    font-size: 15.6429px;
    line-height: 22px;
    color: #2e2f2f;
  }
  .for_mobile .card_wrapper .name_img .name div {
    font-weight: 400;
    font-size: 14.6429px;
    line-height: 22px;
    color: #2e2f2f;
  }
}
</style>
